import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", {
    ...required,
    message: "Ce champ est obligatoire !",
});

export default {
	name: 'caisse-paiement-dette',
	components: {
		ValidationProvider,
        ValidationObserver
	},
	props: [
		'user_id', 'compte_id'
	],
	data() {
		return {
			dette: {
				user_id: 0,
				compte_id: 0,
				d_date: '',
				d_patient: '',
				d_motif: '',
				d_montant: ''
			},
			loading: false,
			btn_disable: false
		}
	},
	computed: {

	},
	mounted() {

	},
	methods: {
		/**
		 * Validation du formulaire
		 */
		onSubmit() {
			this.loading = true;
			this.btn_disable = true

            this.$refs.form.validate().then((success) => {
                if (!success) {
                    this.loading = false;
					this.btn_disable = false
                    return;
                }
			})

			this.dette.user_id = this.user_id
			this.dette.compte_id = this.compte_id

			this.$store.dispatch("storePaiementDettePatient", { dette: this.dette }).then(() => {
				this.$emit('updateLigneOperation')

				this.dette = {
					user_id: 0,
					compte_id: 0,
					d_date: '',
					d_patient: '',
					d_motif: '',
					d_montant: ''
				}
				this.loading = false;
				this.btn_disable = false
				this.$refs.close_modal.click()
				this.doSuccessMsg()
			})
		},

		doSuccessMsg: function() {
            this.$toasted.show('Paiemnent de dette patient enregistré avec succès', {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'success'
            })
        }
	}
}


